import React, { Component } from 'react';
import classNames from 'classnames';
import {withRouter,NavLink} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {withContext} from '../../custom/StateProvider';
import {connect} from "react-redux";
import Typography from '@material-ui/core/Typography';
import {FusePageSimple} from '@fuse';
import {Paper, List, ListItem, ListItemText} from "@material-ui/core";
import InvestorHoldings from "./reports/investorHoldings"
import InvestorBalance from "./reports/investorBalance"
import CompletedTrades from "./reports/completedTrades"

const headerHeight = 60;

const styles = theme => ({
  root                    : {},
  avatar                  : {},
  layoutHeader            : {
    height   : headerHeight,
    minHeight: headerHeight
  },
  layoutContentCardWrapper: {
    padding      : 24,
    paddingBottom: 80
  },
  layoutLeftSidebar       : {
    width: '400px',
    marginBottom:'50px'
  },
  addButton               : {
    position: 'absolute',
    right   : 12,
    bottom  : 12,
    zIndex  : 99
  }
});

class Reporting extends Component {

  componentDidMount() {

  }

  render() {
    const { classes} = this.props;
    return (
      <FusePageSimple
    className={classes.root}
    classes={{
      root              : classes.layoutRoot,
        contentCardWrapper: classes.layoutContentCardWrapper,
        leftSidebar       : classes.layoutLeftSidebar,
        header            : classes.layoutHeader
    }}
    header={
    <div className={classNames("flex flex-1 flex-col sm:flex-row items-center justify-between p-24")}>
      <Typography variant="title" color="inherit" className={"flex-1"}>
        Reporting
      </Typography>
    </div>
  }
    content={
      <div className={'flex-1 p-12'} style={{position:'relative'}}>
        {(typeof this.props.match.params.report === 'undefined') &&
          <span>No Report Selected</span>
        }
        {(this.props.match.params.report === 'holding_report') &&
          <React.Fragment>
            <h3>Investor Holdings</h3>
            <InvestorHoldings />
          </React.Fragment>
        }
        {(this.props.match.params.report === 'wallet_report') &&
        <React.Fragment>
          <h3 style={{textAlign:'center'}}>Investor Wallet Balances</h3>
          <InvestorBalance />
        </React.Fragment>
        }
        {(this.props.match.params.report === 'completed_trades') &&
        <React.Fragment>
          <h3 style={{textAlign:'center'}}>Last 200 Completed Trades</h3>
          <CompletedTrades />
        </React.Fragment>
        }

      </div>
    }

    leftSidebarContent={
      <div className={classNames(classes.root, "lg:p-24 lg:pr-4")}>
          <Paper className={'flex-1'} style={{position:'relative'}}>
            <List>
              <ListItem
                button
                to={'/reporting/holding_report'}
                component={NavLink}
                activeClassName="active"
                className={classes.listItem}
              >
                <ListItemText primary="Investor Holding Report" disableTypography={true}/>
              </ListItem>
              <ListItem
                button
                to={'/reporting/wallet_report'}
                component={NavLink}
                activeClassName="active"
                className={classes.listItem}
              >
                <ListItemText primary="Investor Wallet Report" disableTypography={true}/>
              </ListItem>
              {/*<ListItem
                button
                to={'/reporting/holding_statement'}
                component={NavLink}
                activeClassName="active"
                className={classes.listItem}
              >
                <ListItemText primary="Investor Holding Statements" disableTypography={true}/>
              </ListItem>*/}
              <ListItem
                  button
                  to={'/reporting/completed_trades'}
                  component={NavLink}
                  activeClassName="active"
                  className={classes.listItem}
              >
                <ListItemText primary="Last 200 Completed Trades" disableTypography={true}/>
              </ListItem>
            </List>
          </Paper>
      </div>
  }
    sidebarInner
    onRef={instance => {
      this.pageLayout = instance;
    }}
    />
    )
  }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Reporting))));
